export function formatDistance(meters: number) {
  if (meters >= 1000) {
    // Convert to kilometers, round to 1 decimal if < 10000, else no decimals
    const km = meters / 1000;
    const rounded = km < 10000 ? Math.round(km * 10) / 10 : Math.round(km);
    return `${rounded}${Number.isInteger(rounded) ? "" : ""} km`;
  } else {
    // Round to nearest integer for meters
    return `${Math.round(meters)} m`;
  }
}
